<div class="notification-container">
    <div
        *ngFor="let notification of notifications; trackBy: trackById"
        class="notification"
        [class.notification-success]="notification.type === 'success'"
        [class.notification-error]="notification.type === 'error'"
        [class.notification-warning]="notification.type === 'warning'"
        [class.notification-info]="notification.type === 'info'"
    >
    <div class="notification-content">
        <h4 class="notification-title">{{ notification.title }}</h4>
        <p class="notification-message">{{ notification.message }}</p>
        
        <div class="notification-actions" *ngIf="notification.actions && notification.actions.length > 0">
        <button
            *ngFor="let action of notification.actions"
            class="notification-action-btn"
            (click)="handleAction(action.action); dismiss(notification.id)"
        >
            {{ action.label }}
        </button>
        </div>
    </div>
    
    <button class="notification-close" (click)="dismiss(notification.id)">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
        <path d="M3.72 3.72a.75.75 0 011.06 0L8 6.94l3.22-3.22a.75.75 0 111.06 1.06L9.06 8l3.22 3.22a.75.75 0 11-1.06 1.06L8 9.06l-3.22 3.22a.75.75 0 01-1.06-1.06L6.94 8 3.72 4.78a.75.75 0 010-1.06z"/>
        </svg>
    </button>
    </div>
</div>